
import Cosme from '../Image/Tratamientos/cosme.png';
import Corpo from '../Image/Tratamientos/corpo.png';
import ManosPies from '../Image/Tratamientos/manosPies.png';
import CejasPestañas from '../Image/Tratamientos/cejasPestañas.png';
import Depi from '../Image/Tratamientos/depi.png';

const DataTratamientos = [
    {
        img: CejasPestañas,
        title: "Cejas y Pestañas",
        description: "Resaltá los rasgos y las facciones de tu rostro y descubrí tu mejor versión",
        link: "/CejasPestañas"
    },
    {
        img: ManosPies,
        title: "Manos y Pies",
        description: "Además de la belleza de tu rostro, hacé brillar tus manos y pies",
        link: "/ManosPies"
    },
    {
        img: Cosme,
        title: "Faciales",
        description: "Elegí el tratamiento ideal para pieles oleosas, secas, rosaceas o poros dilatados.",
        link: "/Cosme"
    },
    {
        img: Corpo,
        title: "Corporales",
        description: "Necesitas tratar la flacides, celulitis, o esos kilitos de mas? Elegí tu tratamiento ideal",
        link: "/Corpo"
    },
    {
        img: Depi,
        title: "Depilación Definitiva y Tradicional",
        description: "Sentirte suave es sentirte esplendida, elegí la forma que va con vos",
        link: "/Depi"
    }
]

export default DataTratamientos;